import { insightsClient } from '@app/helpers/requests/client';

export const fetchInsights = ({ path }) => insightsClient.get(`/v1${path}`);
